import script from "./HeaderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&setup=true&lang=js"

import "./HeaderComponent.vue?vue&type=style&index=0&id=7bfd4a3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bfd4a3e"]])

export default __exports__